import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetUserTeamsQuery } from "../../features/members/membersApi";
import { teamsApi } from "../../features/teams/teamsApi";
import NoContent from "../ui/NoContent";
import Team from "./Team";
import Error from "../ui/Error";
import Loading from "../ui/Loading";

export default function AllTeams() {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth) || {};
    const { email } = user || {};

    // Get member list of team for user
    const {
        data: userTeams,
        isLoading,
        isError,
    } = useGetUserTeamsQuery(email) || {};

    const [teams, setTeams] = useState([]);

    // Get user all teams
    useEffect(() => {
        if (userTeams?.length > 0) {
            const allTeams = userTeams?.map((tId) => tId.teamId);

            dispatch(teamsApi.endpoints.getTeams.initiate(allTeams))
                .unwrap()
                .then((data) => {
                    setTeams(data);
                })
                .catch((err) => {});
        }
    }, [userTeams, dispatch]);

    let content = null;

    if (isLoading) {
        content = <Loading />;
    }

    if (!isLoading && isError) {
        content = <Error message="Something wrong" />;
    }

    if (!isLoading && !isError && teams.length === 0) {
        content = <NoContent message="No team found" />;
    }

    if (!isLoading && !isError && teams.length > 0) {
        content = (
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 px-10 mt-4 gap-6 overflow-auto">
                {teams.map((team) => (
                    <Team key={team.id} team={team} />
                ))}
            </div>
        );
    }

    return content;
}
